import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartItemsCookieService } from '../Services/cartItemsCookie.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { Course } from '../Models/course.model';
import { a } from '@angular/core/src/render3';

@Component({
  selector: 'app-work-shops',
  templateUrl: './work-shops.component.html',
  styleUrls: ['./work-shops.component.css']
})
export class WorkShopsComponent implements OnInit {
  allCourses:Course[];
  scheduledCourses:Course[];
  futureCourses: Course[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private cartItemsCookieService: CartItemsCookieService,
    private snotifyService: SnotifyService,
  ) { }

  ngOnInit() {

    document.querySelector('#componentTop').scrollIntoView({ behavior: 'smooth', block: 'center' });

    this._route.data.subscribe(
      ({allCourses}) => {
      console.log('allcourses: ', allCourses);
      this.allCourses = allCourses;
      this.scheduledCourses = allCourses.filter((c) => c.category == "scheduled");
      this.futureCourses = allCourses.filter((c) => c.category == "future");
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/work-shops/work-shops.component.ts